export default process.env.NODE_ENV === 'production' ? 'https://poze-tgmures.verdedata.ro' : 'http://localhost:9533'
// export default process.env.NODE_ENV === 'production' ? 'https://poze-tgmures.verdedata.ro' : 'https://poze-tgmures.verdedata.ro'
